import View from '../view';

import { fmt } from '../../utils/date';
import { hashify } from '../../utils/arrays';





export default View.extend( {

    serialize() {
        const { calendar, collection, fiveLines } = this.options;

        const data = this.options.data ||
            collection && hashify( collection.toJSON(),
                item => [fmt( item.date, 'YYYY-MM-DD' ), item] ) ||
            {};

        return {
            dates: calendar.list()
                .filter( (_, index) => !fiveLines || index < 35 )
                .map( item => (item.data = data[fmt( item.date, 'YYYY-MM-DD' )], item) ),
        };
    },

} );


// WEBPACK FOOTER //
// ./src/js/view/widget/calendar.js